const backend = process.env.NODE_ENV === 'production' ? 'https://la-segunda-mano-qh3p.onrender.com' : 'https://la-segunda-mano-qh3p.onrender.com';

export default backend;
